<template lang="pug">
ValidationProvider(
  v-slot="{ errors }"
  :rules="required ? 'required' : ''"
  name="project_id"
)
  .form-group(:class="{ 'has-error': errors[0] }")
    .row.margin-bottom-sm
      .col-sm-12
        .row(v-if="!disabled && !secondaryProjectOptionsIsEmpty && !manualTimeRequest")
          .col-xs-6
            label.control-label.grouped_select {{ projectLabel }}*
          .col-xs-6
            .control-label-btn.pull-right.organizations(v-if="multiOrganization")
              a(
                v-if="showCurrentOrganization"
                @click="setSecondaryProjectOptions"
              ) Show all organizations
              a(
                v-else
                @click="setProjectOptions"
              ) Hide other organizations
        label.control-label.grouped_select(v-else) {{ projectLabel }}*
        AppSelect(
          ref="select"
          v-model="projectId"
          async
          :disabled="disabled"
          :select2-options="getSelect2Options"
        )
    span.help-block {{ errors[0] }}
</template>

<script>
import { isEmpty } from 'lodash-es';
import { mapActions, mapGetters, mapState } from 'vuex';
import { getProjectFlavourLabel } from '~/utils/project_flavour';

export default {
  name: 'TimeEntriesProjectSelect',
  props: {
    value: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    projectOptions: {
      type: Array,
      default: null,
    },
    secondaryProjectOptions: {
      type: Array,
      default: null,
    },
    required: {
      type: Boolean,
      default: true,
    },
    manualTimeRequest: {
      type: Boolean,
      default: false,
    },
    extendTimeUsingManualTimeRequest: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['showCurrentOrganization']),
    ...mapGetters(['projectFlavour', 'organizations']),
    getSelect2Options() {
      return {
        allowClear: false,
        placeholder: this.placeholder,
        multiple: false,
        data: this.options,
        width: '100%',
      };
    },
    showOnlyCurrentOrganization() {
      return this.secondaryProjectOptionsIsEmpty || !this.multiOrganization || this.manualTimeRequest;
    },
    options() {
      return this.showCurrentOrganization || this.showOnlyCurrentOrganization
        ? this.projectOptions
        : this.secondaryProjectOptions;
    },
    projectId: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue);
      },
    },
    projectLabel() {
      return getProjectFlavourLabel(this.projectFlavour, false, this.manualTimeRequest && !this.extendTimeUsingManualTimeRequest);
    },
    placeholder() {
      return `Select a ${this.projectLabel.toLowerCase()}`;
    },
    secondaryProjectOptionsIsEmpty() {
      return isEmpty(this.secondaryProjectOptions);
    },
    multiOrganization() {
      return this.organizations.length > 1;
    },
  },
  created() {
    this.loadState({ showCurrentOrganization: !this.secondaryProjectOptionsIsEmpty });
  },
  methods: {
    ...mapActions(['loadState']),
    setSecondaryProjectOptions() {
      this.loadState({ showCurrentOrganization: false });
    },
    setProjectOptions() {
      this.loadState({ showCurrentOrganization: true });
    },
  },
};
</script>
